import React from 'react';
import { ClientData } from '../types';
import { toRichTextHtml } from './RichTextEditor';

interface ClientGeneralInfoPageProps {
  clientData: ClientData;
}

export default function ClientGeneralInfoPage({ clientData }: ClientGeneralInfoPageProps) {
  const generalInfo = clientData.pageContent?.generalInfo;
  const hasExplicitTopTitleFields = Boolean(generalInfo?.topTitle || generalInfo?.topTitleSubhead);
  const topTitle = generalInfo?.topTitle || generalInfo?.headline || clientData.headline || 'General Info';
  const topTitleSubhead = generalInfo?.topTitleSubhead || generalInfo?.subhead || clientData.introduction || '';
  const contentHeadline = hasExplicitTopTitleFields ? (generalInfo?.headline || '') : '';
  const contentSubhead = hasExplicitTopTitleFields ? (generalInfo?.subhead || '') : '';
  const mainContent = toRichTextHtml(generalInfo?.mainContent || '');
  const theme = clientData.uiSettings?.theme;
  const primary = theme?.primary || '#14B8A6';
  const clientName = clientData.name;

  return (
    <div className="min-h-screen bg-slate-100">
      <section className="relative overflow-hidden">
        <div
          className="min-h-[24vh] md:min-h-[28vh] flex items-center py-5"
          style={{
            background: `linear-gradient(135deg, ${primary}, rgba(14,116,144,0.95))`,
          }}
        >
          <div className="container mx-auto px-6 py-16">
            <div className="max-w-4xl">
              <div className="text-xs uppercase tracking-[0.4em] text-white/70 mb-3">Littlefield Agency</div>
              <h1 className="text-3xl leading-9 md:text-4xl md:leading-10 font-bold mb-3 text-white">{clientName}</h1>
              <div className="max-w-3xl">
                <h2 className="text-lg leading-7 font-semibold mb-2" style={{ color: '#ffffffd9' }}>{topTitle}</h2>
                {topTitleSubhead && <p className="text-base leading-6 font-normal max-w-3xl" style={{ color: '#ffffffd9' }}>{topTitleSubhead}</p>}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative -mt-10 z-10 pb-20">
        <div className="container mx-auto px-6">
          <article className="max-w-[900px] mx-auto bg-white rounded-2xl shadow-lg border border-white/20 p-6 md:p-10">
            {(contentHeadline || contentSubhead) && (
              <header className="mb-6">
                {contentHeadline && <h2 className="text-3xl font-bold text-slate-900 mb-2">{contentHeadline}</h2>}
                {contentSubhead && <p className="text-slate-600 text-lg">{contentSubhead}</p>}
              </header>
            )}
            {mainContent ? (
              <div
                className="prose prose-slate max-w-none"
                dangerouslySetInnerHTML={{ __html: mainContent }}
              />
            ) : (
              <p className="text-slate-600">No content added yet.</p>
            )}
          </article>
        </div>
      </section>
    </div>
  );
}
